import {
  InputLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { get } from "lodash";
import React from "react";

import { INVOICE_STATUS_ITEMS_MAP } from "components/form/forms/voucher/InvoicesField";
import { formatDateForDisplay } from "components/form/standard/utils/formatting";
import { InvoiceActionsMenu } from "components/form_v2/detail/invoice/InvoiceActionsMenu";
import { DealBaseMetadata } from "constants/objectMetadata/dealMetadataV2";
import { formatCurrency } from "pages/deal/utils/reporting";
import { DealExtended } from "types/api/deal/dealExtended";
import { InvoiceRead } from "types/api/deal/invoice";

const InvoicesDetail = ({ record }: { record: DealExtended }) => {
  return (
    <Stack spacing={1}>
      <InputLabel> {DealBaseMetadata.invoices.displayName}</InputLabel>
      <TableContainer>
        <Table sx={{ minWidth: 800 }}>
          <TableHead>
            <TableRow>
              <TableCell>Invoice Date</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Invoice Number</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {record.invoices.map((detail: InvoiceRead, index: number) => (
              <TableRow key={index}>
                <TableCell>{formatDateForDisplay(detail.date)}</TableCell>
                <TableCell>{formatCurrency(Number(detail.amount))}</TableCell>
                <TableCell>{detail.description || "--"}</TableCell>
                <TableCell>{detail.invoice_code || "--"}</TableCell>
                <TableCell>
                  {get(INVOICE_STATUS_ITEMS_MAP, detail.status, "--")}
                </TableCell>
                <TableCell align="center">
                  {!!detail?.id && <InvoiceActionsMenu invoice={detail} />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default InvoicesDetail;
